import React from 'react'
import styled from 'react-emotion'
import { color } from 'stylist'
import { HoverMenu } from '../HoverMenuPlugin'

export const elementChildPadding = `
  padding-left: 10px;
  padding-right: 10px;
`

const ElementOuterWrapper = styled.div`
  width: 100%;
  &:hover {
    .element-more-icon {
      visibility: visible;
    }
  }
`

const ElementInnerWrapper = styled.div`
  display: inline-block;
  width: 840px;
  margin-left: 4px;
  padding-top: 4px;
  padding-bottom: 15px;
  border-radius: 3px;
  .element-answer-row,
  p {
    ${elementChildPadding};
  }
  &:hover {
    background-color: #f5f7f9;
  }
`

const Header = styled('div')`
  margin-bottom: 4px;
  ${elementChildPadding};
`

const Body = styled.div`
  margin-top: 4px;
  color: ${color('ink')};
`

const LabelSpan = styled.span`
  padding: 3px 5px;
  font-size: 14px;
  color: ${color('pewter')};
  background-color: #eff1f2;
  border-radius: 3px;
  display: none;
`

const TypeIconWrapper = styled.span`
  position: relative;
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  display: inline-block;
  vertical-align: top;
  padding-top: 8px;
`

const TypeIconSpan = styled.span`
  font-size: 20px;
  color: ${color('cadet')};
  border-radius: 2px;
  cursor: pointer;

  &:hover {
    background-color: ${color('paleGrey')};
  }

  &.open {
    color: ${color('white')};
    background-color: ${color('pewter')};
  }

  &:before {
    margin-left: 5px;
    margin-right: 5px;
  }
`

const Label = props => {
  return (
    <LabelSpan className={props.className}>
      {React.Children.map(props.children, (child, ix) => {
        if (ix === 0) {
          return child
        }
        return null
      })}
    </LabelSpan>
  )
}

class TypeIcon extends React.Component {
  state = { open: false }

  constructor(props) {
    super(props)

    this.ref = React.createRef()
  }

  componentDidUpdate() {
    if (this.state.open) {
      document.addEventListener('click', this.closeMenu)
    } else {
      document.removeEventListener('click', this.closeMenu)
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closeMenu)
  }

  onClick = ev => this.props.editor.blur()

  toggleMenu = ev => this.setState({ open: !this.state.open })

  closeMenu = ev => {
    this.setState({ open: false })
  }

  render() {
    const { show = true, name } = this.props
    const { open } = this.state
    const classes = ['type-icon', name]

    open && classes.push('open')

    return (
      <TypeIconWrapper
        contentEditable={false}
        onClick={this.onClick}
        show={show}
      >
        <TypeIconSpan
          onClick={this.toggleMenu}
          className={classes.join(' ')}
          innerRef={this.ref}
        />
        {this.state.open ? (
          <HoverMenu {...this.props} targetRef={this.ref} />
        ) : null}
      </TypeIconWrapper>
    )
  }
}

class BaseElement extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    return (
      <ElementOuterWrapper
        className={`element ${this.props.className}`}
        innerRef={this.props.innerRef}
      >
        <TypeIcon name={this.props.iconName} {...this.props} />
        <ElementInnerWrapper className="element-inner-wrapper">
          <Header>
            <Label className="element-label" {...this.props}>
              {this.props.children}
            </Label>
          </Header>
          <Body>
            {React.Children.map(this.props.children, (child, ix) => {
              if (ix > 0) {
                return child
              }
              return null
            })}
          </Body>
        </ElementInnerWrapper>
      </ElementOuterWrapper>
    )
  }
}

const AnswerControl = styled.span`
  position: relative;
  font-size: 10px;
  color: ${color('cadet')};
  margin-right: 5px;
  bottom: 1px;
`
const Title = props => <p>{props.children}</p>
const AnswerRowStyled = styled.div`
  position: relative;
  padding-top: 4px;
  padding-bottom: 4px;
  &:hover {
    background-color: #e4e8eb;
  }
`

const AnswerRow = props => (
  <AnswerRowStyled className="element-answer-row" {...props} />
)

BaseElement.Label = Label
BaseElement.Title = Title
BaseElement.AnswerRow = AnswerRow
BaseElement.AnswerControl = AnswerControl
BaseElement.TypeIcon = TypeIcon
BaseElement.elementChildPadding = elementChildPadding

export default BaseElement



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/ElementPlugin/Element.js